import backend from '@common/backend';

export interface IUploadAvatarBody {
	avatar_url: string;
}

const profileFromBE = (profile: any) => ({
	...profile,
	services: profile.services.map((service: any) => service.id),
});

export const getProfile = () => backend.get('/profile').then(profileFromBE);

export const postAvatar = (body: IUploadAvatarBody) => backend.post('/avatar/update', body);
